export const initialState = {
  values: {
    city: '',
    country: '',
    state: '',
    keyword: '',
    qty: '',
    qtyName: '',
    currency: '',
    closingDate: '',
    searchCategory:'',
    searchSubCategory:'',
    priceTo:'',
    priceFrom:'',
  },
  errors: {
    city: '',
    state: '',
    country: '',
    keyword: '',
    qty: '',
    qtyName: '',
    searchCategory:'',
    searchSubCategory:'',
    priceTo:'',
    priceFrom:'',
    currency: '',
    closingDate: '',
  },
}
